import { render, staticRenderFns } from "./hardwareEight.vue?vue&type=template&id=1a0e2c10&scoped=true"
import script from "./hardwareEight.vue?vue&type=script&lang=js"
export * from "./hardwareEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e2c10",
  null
  
)

export default component.exports